import { debounceTime } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PortalProductsService } from '../../services/portal-products.service';
import { AccountService } from '../../services/account.service';
import { SuperAdminService } from '../../services/super-admin.service';
import { LovDataService } from '../../services/lov-data.service';
import { GetPortalProductIdFromKey, GetPortalProductFromKey } from '../../data/portal-products';

export class ProductFormBase {
  fb: FormBuilder;
  portalProductsService: PortalProductsService;
  accountService: AccountService;
  superAdminService: SuperAdminService;
  lovDataService: LovDataService;
  productForm: FormGroup;
  formSaveStatus: { status: string; date?: Date; message?: string };
  formSubmitted = false;
  constructor(fb, portalProductsService, accountService, lovDataService, superAdminService) {
    this.fb = fb;
    this.portalProductsService = portalProductsService;
    this.accountService = accountService;
    this.lovDataService = lovDataService;
    this.superAdminService = superAdminService;
  }

  getFb() {
    return this.fb;
  }

  buildForm(productkey, formDefinition, userId) {
    this.productForm = this.fb.group(formDefinition);

    console.log(this.productForm, 'productForm 3333333333333', GetPortalProductIdFromKey(productkey));
    this.productForm.valueChanges.pipe(debounceTime(800)).subscribe(async (value) => {
      let attachments = this.getAttachment(value);
      console.log(attachments);
      let data = {
        productId: `${GetPortalProductIdFromKey(productkey)}`,
        values: value,
        attachments: attachments,
      };

      //   await this.transformForServer(data, userId);
      // console.log(this.productForm)
      if (this.productForm.invalid) {
        // console.log(this.productForm);
        Object.keys(this.productForm.controls).forEach((k) => {
          if (k && this.productForm.controls[k] && this.productForm.controls[k].errors) {
          }
        });
      }
      try {
        this.formSaveStatus = {
          status: 'in-progress',
        };
        await this.portalProductsService.saveSignupForm(data, userId);
        let product = GetPortalProductFromKey(productkey);
        if (product && !product.status) {
          this.portalProductsService.mergeProductStatus();
        }

        setTimeout(() => {
          this.formSaveStatus = {
            status: 'success',
          };
        }, 650);
      } catch (e) {
        if (userId) {
          this.formSaveStatus = {
            status: 'error',
            message: `${e.error.message}`,
          };
        } else {
          this.formSaveStatus = {
            status: 'error',
            message: 'Error occured saving. Please check your internet.',
          };
        }
      }
    });
  }

  getAttachment(value) {
    let attachementArray = [];
    [
      'boAttachment',
      'firstApplicantPhotoAttachment',
      'nidPassportDrivingBothSideAttachment',
      'firstApplicantSignatureAttachment',
      'firstApplicantTINAttachment',
      'firstApplicantBankStatementAttachment',
      'nominee1ApplicantPhotoAttachment',
      'nominee1ApplicantNIDAttachment',
      'nominee1ApplicantSignatureAttachment',
      'nominee2ApplicantSignatureAttachment',
      'nominee2ApplicantPhotoAttachment',
    ].map((key) => {
      value[key] && attachementArray.push(value[key]);
    });
    return attachementArray;
  }
}
